<script>
    export default {
        name: 'OutlineIcon',
        props: {
            width: {
                type: [Number, String],
                required: false,
                default: 24,
            },
            height: {
                type: [Number, String],
                required: false,
                default: 24,
            },
            rotate: {
                type: Number,
                required: false,
                default: 0,
            },
        },
        computed: {
            rotateProperty() {
                return `rotate(${this.rotate} ${this.width / 2} ${this.height / 2})`;
            },
        },
    };
</script>

<template>
    <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" class="fill-current">
        <g :transform="rotateProperty">
            <path
                d="M9.29 15.88L13.17 12 9.29 8.12a.996.996 0 111.41-1.41l4.59 4.59c.39.39.39 1.02 0 1.41L10.7 17.3a.996.996 0 01-1.41 0c-.38-.39-.39-1.03 0-1.42z" />
        </g>
    </svg>
</template>
